import styled from "@emotion/styled";
import {PrimaryButton} from "views/components/common";
import {PureButton} from "views/components/common/buttons/pureButton";

export const ModalContent = styled.div`
	position: absolute;
	left: 20px;
	right: 20px;
	top: 50px;
	max-width: 600px;
	margin: 0 auto;
	-webkit-border-radius: 8px;
	-moz-border-radius: 8px;
	border-radius: 8px;
	background: #545456;
	color: #ffffff;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding: 68px 20px 20px 20px;
	gap: 12px;

	@media (max-width: 400px) {
		padding-top: 10px;
		top: 20px;
	}

	@media (max-height: 400px) {
		height: 100%;
		max-height: 700px;
		overflow-y: scroll;
		padding-bottom: 80px;
	}

	&.full-screen {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}
`;

export const ModalCloseButton = styled(PureButton)`
	-webkit-border-radius: 0;
	-moz-border-radius: 0;
	border-radius: 0;
	position: absolute;
	right: 20px;
	top: 20px;
	width: 24px;
	height: 24px;
	padding: 0;
`;

export const ModalTitle = styled.h3`
	font-style: normal;
	font-weight: 700;
	font-size: 20px;
	line-height: 118%;
	text-align: center;
	letter-spacing: 0.01em;
	text-transform: uppercase;
	color: #ffffff;
	margin: 30px 0 10px 0;
`;

export const ModalText = styled.p`
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 140%;
	color: #ffffff;
	text-align: center;
	letter-spacing: 0.01em;
	font-family: "Hind", sans-serif;
	margin: 10px;
`;

export const ModalButton = styled(PrimaryButton)`
	max-width: 420px;
	width: 100%;
	margin-top: 12px;
`;
